import { Inputs } from "../../../../pages/public/authentication/signUp/steps/SignUpAccount"
import { ArticleSection } from "../../../../redux/supportAndGuides/supportArticlesType"
import { BUList } from "../../../../redux/user/userTypes"

export const sections = [
    { label: 'Premiers pas', value: ArticleSection.FIRST_STEPS },
    {
        label: `Cas d'usage métiers`,
        value: ArticleSection.USECASES
    },
]

export const BUListToDisplay = [BUList.DATA_SI, BUList.CATEGORY_MANAGER_MARKETING, BUList.DISTRIBUTION, BUList.BUSINESS]

export const inputsArticleForm: Inputs[] = [
    { type: 'text', name: 'title', label: 'Titre' },
    { type: 'text', name: 'description', label: 'Description' },
    { type: 'text', name: 'link', label: "Lien de l'article" }]
